export default __webpack_public_path__ + "static/media/mini_map.cc58230e.svg";